<template>
  <Modal v-model="addLogisticsModal" class-name="addLogisticsStyle" :title="$t('key1005209')" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="addLogisticsModalChange">
    <Form ref="addLogisticsModalForm" :model="addLogisticsModalForm" :rules="ruleValidate" :label-width="120" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005210')" prop="type" class="radio_styles">
            <RadioGroup v-model="addLogisticsModalForm.type">
              <Radio v-for="item in typeList" :label="item.value">{{ item.name }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="addLogisticsModalForm.type === '1'">
          <Form-item :label="$t('key1005211')" prop="logisticsList">
            <Select v-model="addLogisticsModalForm.logisticsList" multiple filterable>
              <Option v-for="(item,index) in logisticsData" :key="index" :value="item.carrierCode">{{ item.carrierName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList" v-else>
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="labelRander(item)" :prop="'carrierName_' + item.code" :rules="getRules(item)">
                  <Input clearable v-model.trim="addLogisticsModalForm['carrierName_' + item.code]" class="wid100P"></Input>
                </Form-item>
              </Col>
            </template>
          </template>
        </languagesTabs>
      </Row>
    </Form>
    <template #footer>
      <Button @click="addLogisticsModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="addLogisticsBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import languagesTabs from "@/components/common/languagesTabs.vue";

export default {
  name: "addLogisticsModal",
  components: {languagesTabs},
  mixins: [Mixin],
  data() {
    return {
      addLogisticsModal: false,
      addLogisticsModalForm: {
        type: '1',
        logisticsList: [],
        carrierName: '' // 自定义物流商名称
      },
      ruleValidate: {
        logisticsList: [
          {
            type: 'array',
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001359'),
            trigger: 'change'
          }
        ]
      },
      typeList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005208'), value: '1'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003797'), value: '2'}

      ],
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      logisticsData: [],
    };
  },
  methods: {
    // 初始化数据
    initLogisticsData() {
      this.initMultilingualFields('addLogisticsModalForm', this.addLogisticsModalForm, ['carrierName_']).then(() => {
        this.getLogisticsProviderData();
        this.addLogisticsModal = true;
      });
    },
    // 获取API对接--未启用的物流商基础数据
    getLogisticsProviderData() {
      this.axios.get(api.get_carrier_queryForDisableCarriers + '?searchValue=').then(response => {
        if (response.data.code === 0) {
          this.logisticsData = response.data.datas || [];
        }
      });
    },

    // 新增物流弹窗的确定按钮
    addLogisticsBtn() {
      let v = this;
      v.$refs['addLogisticsModalForm'].validate(function (valid) {
        if (valid) {
          // API对接
          if (v.addLogisticsModalForm.type === '1') {
            let list = v.addLogisticsModalForm.logisticsList || [];
            v.axios.post(api.post_carrier_insertWithApi, list, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.addLogisticsModal = false;
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456'));
                v.$emit('updateData', true);
              }
            });
          }
          // 自定义
          else {
            let query = {
              carrierName: v.handleMultilingualSingleParam(v.addLogisticsModalForm, 'carrierName_')
            };
            v.axios.post(api.post_carrier_addDefine, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.addLogisticsModal = false;
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456'));
                v.$emit('updateData', true);
              }
            });
          }
        }
      });
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 监听弹窗
    addLogisticsModalChange(value) {
      if (!value) {
        this.$refs['addLogisticsModalForm'].resetFields();
      } else {
        this.$nextTick(() => {
          if (this.$refs['languagesTab']) {
            this.$refs['languagesTab'].tabName = this.languagesVal;
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.addLogisticsStyle {
  label.ivu-radio-wrapper {
    font-size: 12px;
  }
}
</style>
